var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1317.000000, -589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1317.000000, 589.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-23-Copy-5",
    fill: "#357BEB"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-42",
    cx: 19,
    cy: 19,
    r: 19
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.989531,9 L29,17.010469 L27.6617823,18.3298428 L27.0020921,17.6701591 L23.0062828,21.6659684 L22.3277488,25.002094 L20.989531,26.3403137 L16.9937153,22.3256521 L12.3382203,27 L11,25.6617797 L15.6743479,21.0062847 L11.6596863,17.010469 L12.997906,15.6722512 L16.3340316,14.9937172 L20.3298409,10.9979079 L19.6701572,10.3382177 L20.989531,9 Z M21.6680651,12.3361256 L17.2575939,16.7465968 L14.6000023,17.2743476 L20.7256524,23.3999977 L21.2534032,20.7424061 L25.6638744,16.3319349 L21.6680651,12.3361256 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinBlueIcon);
export default __webpack_public_path__ + "static/media/pin_blue_icon.fd60362ccafbaee5bb4a7be119e9c08b.svg";
export { ForwardRef as ReactComponent };